/* @flow */

import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';

import IntlMessageComponent from 'components/formatters/intlMessage';

type FilterTextComponentProps = {
  filterId: string;
  label: string;
  value: string;
  selectFilter: (filterId: string, value: string) => void;
}

export default function FilterTextComponent(props: FilterTextComponentProps) {

  const handleChange = (event: SyntheticInputEvent<HTMLInputElement>) =>
    props.selectFilter(props.filterId, event.target.value);

  return (
    <FormControl component="fieldset" fullWidth>
      <FormLabel component="legend">
        <b><IntlMessageComponent id={props.label} /></b>
      </FormLabel>

      <TextField
        id={props.filterId}
        margin="dense"
        style={{minWidth: "15vw", maxWidth: "15vw"}}
        value={props.value}
        onChange={handleChange}
      />
    </FormControl>
  );
}
